import { Injectable } from '@angular/core';
import { NotificationRuleSeverityEnum } from '@app/generated/graphql';

@Injectable({ providedIn: 'root' })
export class NotificationIconConfig {
  // configuration around the icon to be displayed for a notification
  private _iconMap: Partial<Record<NotificationRuleSeverityEnum, string>> = {
    [NotificationRuleSeverityEnum.Info]: '/assets/icons/general/info.svg',
    [NotificationRuleSeverityEnum.Warning]: '/assets/icons/general/warning.svg',
    [NotificationRuleSeverityEnum.Critical]:
      '/assets/icons/general/warning.svg',
    [NotificationRuleSeverityEnum.Alert]: '/assets/icons/general/warning.svg',
  };

  public getIcon(severity: NotificationRuleSeverityEnum): string {
    return this._iconMap[severity];
  }
}
